var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7118 0C23.199 0 0 23.199 0 51.7118C0 80.2246 23.199 103.424 51.7118 103.424C80.2246 103.424 103.424 80.2246 103.424 51.7118C103.424 23.199 80.2246 0 51.7118 0ZM80.6134 38.1034L47.5645 70.8932C45.6205 72.8372 42.51 72.9668 40.4363 71.0228L22.9398 55.0815C20.8662 53.1375 20.7366 49.8974 22.551 47.8237C24.4951 45.7501 27.7352 45.6205 29.8088 47.5645L43.6764 60.2657L73.226 30.716C75.2997 28.6424 78.5398 28.6424 80.6134 30.716C82.6871 32.7897 82.6871 36.0298 80.6134 38.1034Z",
    fill: "#3E53A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectStatus);
export default __webpack_public_path__ + "static/media/correct_status.8e322e8a305be8d239e960a7247ed4e6.svg";
export { ForwardRef as ReactComponent };